export class ProductOrderAdjustmentService {
    constructor($http, apexApiUrl) {
        'ngInject'
        this.$http = $http
        this.apexApiUrl = apexApiUrl
    }

    /**
     * Create a new prodcut order adjustment
     */
    createProductOrderAdjustment(adjustment) {
        return this.$http({
            method: "POST",
            url: this.apexApiUrl + "product-order-adjustment/",
            headers: {
                "Content-Type": "application/json"
            },
            data: JSON.stringify(adjustment)
        }).then(function (response) {
            return response.data;
        });
    }

    /**
    * Bulk upsert product order adjustments
    */
    bulkUpsertProductOrderAdjustments(request) {
        return this.$http({
            method: "POST",
            url: this.apexApiUrl + "product-order-adjustment/bulk",
            headers: {
                "Content-Type": "application/json"
            },
            data: request
        }).then(function (response) {
            return response.data;
        });
    }

    /**
     * Update the given prodcut order adjustment
     */
    updateProductOrderAdjustment(productOrderAdjustmentID, adjustment) {
        return this.$http({
            method: "PUT",
            url: this.apexApiUrl + "product-order-adjustment/" + productOrderAdjustmentID,
            headers: {
                "Content-Type": "application/json"
            },
            data: JSON.stringify(adjustment)
        }).then(function (response) {
            return response.data;
        });
    }

    /**
     * Delete the given product order adjustment
    */
    deleteProductOrderAdjustment(productOrderAdjustmentID) {
        return this.$http({
            method: "DELETE",
            url: this.apexApiUrl + "product-order-adjustment/" + productOrderAdjustmentID,
            headers: {
                "Content-Type": "application/json"
            }
        }).then(function (response) {
            return response.data;
        });
    }

}
